/*
 * @FilePath     : /es-template/src/config/interceptors/respones/respones.js
 * @Author       : LiYang
 * @Date         : 2021-12-07 11:17:45
 * @LastEditTime: 2023-08-24 20:16:36
 * @LastEditors: liuziwei
 * @Description  : 处理响应数据逻辑
 */
import mpx from '@mpxjs/core'
import { urlsWithoutLoading } from '../config'
import { closeMask } from '@/config/usex'
// import { keysToCamelCase } from '@/utils'

export default res => {
  // const { data, status, requestConfig } = keysToCamelCase(res || {})
  const { data, status, requestConfig } = res || {}
  const { 
    errcode,
    errmsg,
    code,
    msg,
  } = data || {}
  const { url } = requestConfig || {}
  
  var isCommonRequest = urlsWithoutLoading.some(item => url?.indexOf(item) > 0)

  //常用出行人相关模块兼容
  if (!isCommonRequest) {
    closeMask()
    mpx.hideLoading()
  }
  return {
    data: data?.hasOwnProperty('data') ? data.data : data,
    code: typeof errcode === 'undefined' ? code : errcode,
    message: typeof errmsg === 'undefined' ? msg : errmsg,
    success: status === 200 && !!data
  }
}
